/* KK Recently viewed. Remembers product handles in this browser (localStorage, newest first),
   then builds cards with the same markup as snippets/kk-card.liquid so the shared
   size-chip + Add to cart handlers in kk-home.js work on them too. */

const KEY = 'kk-recently-viewed';
const MAX = 20;
const root = window.Shopify?.routes?.root || '/';

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]').filter((h) => typeof h === 'string'); } catch { return []; } };
const save = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch { /* private mode: just don't remember */ } };

const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const tidy = (t) => t.replace(/🔥|✅/g, '').replace(/\.{3,}/g, '').trim().toLowerCase().split(/\s+/).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
const fmtEl = document.querySelector('[data-kk-cart-cfg]');
const money = (paise) => {
  const n = paise / 100;
  const amount = new Intl.NumberFormat('en-IN', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
  return (fmtEl?.dataset.moneyFormat || '₹{{amount}}').replace(/\{\{\s*[\w_]+\s*\}\}/, amount);
};
const img = (src, w) => (src ? `${src.startsWith('//') ? 'https:' + src : src}${src.includes('?') ? '&' : '?'}width=${w}` : '');

function card(p, opts) {
  const name = opts.tidy ? tidy(p.title) : p.title;
  const v = p.variants.find((x) => x.available) || p.variants[0];
  const imgs = (p.media || []).filter((m) => m.media_type === 'image').map((m) => m.src);
  const first = imgs[0] || p.featured_image;
  const second = imgs[1];
  const off = v.compare_at_price > v.price ? Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price) : 0;
  const single = p.variants.length === 1;
  const chips = !single && p.options.length === 1 && p.variants.length <= 8;
  const optName = p.options[0]?.name || p.options[0] || 'Size';

  let add = '';
  if (opts.add) {
    if (!p.available) add = `<a class="kk-add kk-add--ghost" href="${esc(p.url)}">View details</a>`;
    else if (single) add = `<button type="button" class="kk-add" data-kk-add data-variant-id="${v.id}" data-label="Add to cart">Add to cart</button>`;
    else if (chips) {
      add = `<div class="kk-chips" role="radiogroup" aria-label="${esc(optName)}"><span class="kk-chips__label">${esc(optName)}</span>${
        p.variants.map((x) => `<button type="button" class="kk-chip" role="radio" aria-checked="false" data-kk-chip data-variant-id="${x.id}" ${x.available ? '' : 'disabled'}>${esc(x.title)}</button>`).join('')
      }</div><button type="button" class="kk-add" data-kk-add data-needs-choice data-label="Add to cart" data-pick="Select ${esc(String(optName).toLowerCase())}">Add to cart</button>`;
    } else add = `<a class="kk-add kk-add--ghost" href="${esc(p.url)}">Choose options</a>`;
  }

  return `<article class="kk-card${p.available ? '' : ' kk-card--soldout'}" data-kk-card data-product-id="${p.id}">
    <a class="kk-card__media" href="${esc(p.url)}" aria-label="${esc(name)}" tabindex="-1">
      ${first ? `<img class="kk-card__img" src="${img(first, 600)}" srcset="${img(first, 300)} 300w, ${img(first, 600)} 600w" sizes="(min-width: 990px) 25vw, 50vw" loading="lazy" alt="${esc(name)}">` : `<span class="kk-card__ph">${esc(name.charAt(0))}</span>`}
      ${second ? `<img class="kk-card__img kk-card__img--alt" src="${img(second, 600)}" loading="lazy" alt="">` : ''}
      <span class="kk-card__badges">${!p.available ? '<span class="kk-badge kk-badge--dark">Sold out</span>' : off ? `<span class="kk-badge kk-badge--off">${off}% OFF</span>` : ''}</span>
    </a>
    <div class="kk-card__body">
      <a class="kk-card__title" href="${esc(p.url)}">${esc(name)}</a>
      <div class="kk-card__price"><span class="kk-card__now">${money(v.price)}</span>${v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : ''}</div>
      ${add}
    </div>
  </article>`;
}

async function init(section) {
  if (section.dataset.kkRecentReady) return;
  section.dataset.kkRecentReady = '1';
  const current = section.dataset.current;
  const limit = Number(section.dataset.limit || 10);
  const opts = { tidy: section.dataset.tidy !== 'false', add: section.dataset.add !== 'false' };

  let list = read();
  const toShow = list.filter((h) => h !== current).slice(0, limit + 4);
  if (current) save([current, ...list.filter((h) => h !== current)]);

  const products = (await Promise.all(toShow.map((h) =>
    fetch(`${root}products/${encodeURIComponent(h)}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null)).catch(() => null)
  ))).filter((p) => p && p.price >= 5000 && !/partial-payment/.test(p.handle)).slice(0, limit);

  // forget products that no longer exist
  if (products.length < toShow.length) {
    const alive = new Set(products.map((p) => p.handle));
    const missing = new Set(toShow.filter((h) => !alive.has(h)));
    save(read().filter((h) => !missing.has(h) || h === current));
  }

  if (!products.length) return;
  section.querySelector('[data-kk-recent-track]').innerHTML = products.map((p) => card(p, opts)).join('');
  section.querySelector('[data-kk-recent-empty]')?.remove();
  section.hidden = false;
  // let the shared row arrows (kk-home.js) measure the new cards
  section.querySelectorAll('[data-kk-row]').forEach((row) => row.querySelector('[data-kk-row-track]')?.dispatchEvent(new Event('scroll')));
}

document.querySelectorAll('[data-kk-recent]').forEach(init);
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll?.('[data-kk-recent]').forEach(init));
